import { TOGGLE_SIDEBAR, CLOSE_SIDEBAR } from "./actionTypes";

export const toggleSidebar = () => ({ type: TOGGLE_SIDEBAR });
export const closeSidebar = () => ({ type: CLOSE_SIDEBAR });
